import { useNavigate } from 'react-router-dom';
import type { Recommendation } from '../../../hooks/useAdvancedInsights';

interface Props { recommendations: Recommendation[]; }

const priorityStyle: Record<Recommendation['priority'], { bg: string; badge: string; badgeText: string; text: string }> = {
  high: { bg: 'bg-red-50 border-red-100', badge: 'bg-red-100 text-red-600', badgeText: 'Alta prioridade', text: 'text-red-700' },
  medium: { bg: 'bg-amber-50 border-amber-100', badge: 'bg-amber-100 text-amber-700', badgeText: 'Média prioridade', text: 'text-amber-700' },
  low: { bg: 'bg-sky-50 border-sky-100', badge: 'bg-sky-100 text-sky-700', badgeText: 'Sugestão', text: 'text-sky-700' },
};

export const InsightsRecommendations = ({ recommendations }: Props) => {
  const navigate = useNavigate();
  if (!recommendations.length) return null;
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-rose-50 rounded-xl">
          <i className="ri-lightbulb-flash-line text-rose-500 text-[16px]" />
        </div>
        <div>
          <h2 className="text-[15px] font-700 text-gray-900">Recomendações</h2>
          <p className="text-[12px] text-gray-400">Ações personalizadas para melhorar sua saúde financeira</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {recommendations.map((rec) => {
          const s = priorityStyle[rec.priority];
          return (
            <div key={rec.id} className={`rounded-2xl border p-4 ${s.bg}`}>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-white rounded-xl shrink-0">
                  <i className={`${rec.icon} ${s.text} text-[17px]`} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <p className={`text-[13px] font-700 ${s.text}`}>{rec.title}</p>
                    <span className={`text-[10px] font-600 px-1.5 py-0.5 rounded-full ${s.badge}`}>{s.badgeText}</span>
                  </div>
                  <p className={`text-[12px] ${s.text} opacity-80`}>{rec.message}</p>
                  {rec.action && (
                    <button
                      onClick={() => navigate(rec.action!)}
                      className={`mt-2 text-[12px] font-600 ${s.text} hover:underline cursor-pointer whitespace-nowrap`}
                    >
                      Ver metas →
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
